import { render, staticRenderFns } from "./search-form.vue?vue&type=template&id=9ffc9b84&scoped=true"
import script from "./search-form.vue?vue&type=script&lang=js"
export * from "./search-form.vue?vue&type=script&lang=js"
import style0 from "./search-form.vue?vue&type=style&index=0&id=9ffc9b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffc9b84",
  null
  
)

export default component.exports